// Nav path → permission menu key map (shared by Layout menu filtering and App route guards).
export const PATH_KEY = [
  ["/customer-master", "customer_master"], ["/customers", "customers"], ["/feedback", "feedback"], ["/campaigns", "campaigns"],
  ["/transactions", "transactions"], ["/item-register", "transactions"], ["/sale-return", "transactions"], ["/purchase-return", "transactions"],
  ["/bookings", "bookings"], ["/vehicles", "vehicles"], ["/jobcards", "jobcards"], ["/estimates", "invoices"], ["/challans", "invoices"],
  ["/invoices", "invoices"], ["/jobrates", "jobrates"], ["/packages", "packages"], ["/reminders", "reminders"],
  ["/items", "items"], ["/companies", "companies"], ["/categories", "categories"], ["/groups", "groups"],
  ["/rates", "rates"], ["/supplier-companies", "supplier_companies"], ["/hsn", "hsn"], ["/stores", "stocks"],
  ["/sectors", "items"], ["/warranties", "items"], ["/labels", "labels"], ["/label-creation", "labels"],
  ["/stocks", "stocks"],
  ["/day-book", "day_book"], ["/cash-book", "cash_book"], ["/bank-book", "bank_book"],
  ["/customer-ledger", "customer_ledger"], ["/ledger", "vendor_ledger"], ["/supplier-master", "supplier_companies"],
  ["/debtor-master", "customers"], ["/expenses", "expenses"], ["/vouchers", "vouchers"],
  ["/gst-reports", "gst_reports"], ["/profit-loss", "profit_loss"],
  ["/insights", "insights"], ["/reports", "reports"], ["/hr", "hrms"],
  ["/organisation", "organisation"], ["/organisation-auth", "organisation"], ["/plan-master", "organisation"],
  ["/users-master", "users"], ["/roles-master", "roles"], ["/permissions-master", "permissions"],
];

export function menuKeyOf(to) {
  if (!to) return null;
  const path = to.split("?")[0];
  if (path === "/") return "dashboard";
  const hit = PATH_KEY.find(([p]) => path === p || path.startsWith(p + "/"));
  return hit ? hit[1] : null;
}

// Roles whose menu/page access is driven by the Role & Permission Master matrix
// instead of the hardcoded static role lists: mechanic + any custom-created role.
const STATIC_ROLE_SET = new Set(["owner", "manager", "cashier", "receptionist", "customer"]);
export function isMatrixDrivenRole(role) {
  return role === "mechanic" || !STATIC_ROLE_SET.has(role);
}
